import {
    Compiler,
    Injector,
    NgModule,
    NgModuleRef,
    Component,
    OnInit,
    HostBinding,
    OnDestroy,
    Input,
    ViewChild,
    ViewContainerRef,
    ComponentRef
} from '@angular/core';
import { CommonModule } from "@angular/common";

import { SharedModule } from '../../shared';

import { Subject } from 'rxjs';

@Component({
    selector: 'app-compile-content',
    template: '<div #vcRef></div>',
    styleUrls: [],
    providers: []
})
export class MenuCompileContentComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @HostBinding('class.--ui') _ui = true;

    @ViewChild('vcRef', { read: ViewContainerRef, static: true }) vcRef: ViewContainerRef;

    @Input() template: string = '';

    private cmpRef: ComponentRef<any>;

    constructor(
        private _compiler: Compiler,
        private _injector: Injector,
        private _moduleRef: NgModuleRef<any>
    ) {
    }

    async ngOnInit() {
        const tmpComponent = Component({
            template: this.template,
            styles: []
        })(class {
            CONFIG = window.CONFIG;
        });

        const tmpModule = NgModule({
            imports: [
                CommonModule,
                SharedModule,
            ],
            declarations: [
                tmpComponent
            ]
        })(class {});

        this._compiler.compileModuleAndAllComponentsAsync(tmpModule)
            .then((factories) => {
                const factory = factories.componentFactories[factories.componentFactories.length - 1];

                this.cmpRef = factory.create(this._injector, [], null, this._moduleRef);
                this.cmpRef.instance.name = 'dynamic';

                this.vcRef.insert(this.cmpRef.hostView);
            });
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();

        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
    }
}
